<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { IconLanguage, IconLogout, IconUser, IconSettings,IconSparkles } from '@tabler/icons-vue'
import { useLocale } from '@/composables/useLocale'
import { useI18n } from 'vue-i18n'
import { enToFaNum,formatNumberWithCommas } from '@/helpers'
const { DIR } = CONFIG


defineProps<{
    ratio?: number
}>()

// emits --------------------
const emits = defineEmits<{
    (e: 'showModal'): void
}>()


// variables -----------------
const { toggleLocale, locale: local } = useLocale()
const isDropdownOpen = ref(false)
const { t } = useI18n()
const dropdownRef = ref<HTMLDivElement | null>(null)

// methods --------------------
const showModal = () => {
    emits('showModal')
}

// Handle clicks outside dropdown
const handleOutsideClick = (event: MouseEvent) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target as Node)) {
    isDropdownOpen.value = false
  }
};


// Add and remove event listener for outside clicks
onMounted(() => {
  document.addEventListener('click', handleOutsideClick)
})

onUnmounted(() => {
  document.removeEventListener('click', handleOutsideClick)
})




</script>


<template>
    <!-- amd -->
    <template v-if="DIR === 'amd'">
        <div class="grow flex flex-nowrap items-center justify-end gap-[10px]">
            <div class="py-[2px] p-2 flex items-center justify-center border-[1px] border-gray-200 rounded-full gap-1">
                <component :is="IconSparkles" size="19" color="#93103C" />
                <span class="text-[9px] text-font-dark">
                    هر امتیاز  معادل <br> <b class="text-font-dark">{{ enToFaNum(formatNumberWithCommas(ratio ?? '0')) }} </b> ریال
                </span>
            </div>
            <div ref="dropdownRef" class="dropdown dropdown-bottom">
                <BaseButton variant="outlines" :is-icon-only="true" :is-circle="true" class="rounded-full"
                    @click="isDropdownOpen = !isDropdownOpen">
                    <template #left>
                        <IconUser size="17" />
                    </template>
                </BaseButton>
                <ul v-show="isDropdownOpen" tabindex="0"
                    class="dropdown-content menu rounded-box z-[1] w-52 !top-11 shadow bg-gray-50"
                    :class="[local === 'fa' ? 'left-0' : 'right-0']">

                    <li @click="isDropdownOpen = false">
                        <BaseButton tag="RouterLink" to="/profile" :is-icon-only="false" variant="trans"
                            class="!justify-between">
                            <template #right>
                                <IconSettings />
                                {{ t('user.userSettings') }}
                            </template>
                        </BaseButton>
                    </li>

                    <li @click="isDropdownOpen = false">
                        <BaseButton :is-icon-only="false" variant="trans" class="!justify-between" @click="showModal">
                            <template #right>
                                <IconLogout color="red" />
                                {{ t('user.logout') }}
                            </template>
                        </BaseButton>
                    </li>
                </ul>
            </div>
        </div>
    </template>
    <!-- rani -->
    <template v-else-if="DIR === 'rani'">
        <div class="grow flex flex-nowrap items-center justify-end gap-[10px]">
            <div class="py-[2px] p-2 flex items-center justify-center border-[1px] border-gray-200 rounded-full gap-1">
                <img src="/img/coin.png" alt="coin" class="w-[19px] h-[19px]">
                <span class="text-[9px] text-font-dark">
                    {{ t('user.coinRani') }} <br> <b class="text-font-dark">{{local === 'fa' ? enToFaNum(formatNumberWithCommas(ratio ?? '0')) : formatNumberWithCommas(ratio ?? '0') }} </b> {{ t('user.rial') }}
                </span>
            </div>
            <BaseButton :is-icon-only="true" :is-circle="true" variant="outlines" @click="toggleLocale">
                <template #left>
                    <component :is="IconLanguage" size="17"></component>
                </template>
            </BaseButton>
            <div ref="dropdownRef" class="dropdown dropdown-bottom">
                <BaseButton variant="outlines" :is-icon-only="true" :is-circle="true" class="rounded-full"
                    @click="isDropdownOpen = !isDropdownOpen">
                    <template #left>
                        <IconUser size="17" />
                    </template>
                </BaseButton>
                <ul v-show="isDropdownOpen" tabindex="0"
                    class="dropdown-content menu rounded-box z-[1] w-52 !top-11 shadow bg-form-box"
                    :class="[local === 'fa' ? 'left-0' : 'right-0']">

                    <li @click="isDropdownOpen = false">
                        <BaseButton tag="RouterLink" to="/profile" :is-icon-only="false" variant="trans"
                            class="!justify-between">
                            <template #right>
                                <IconSettings />
                                {{ t('user.userSettings') }}
                            </template>
                        </BaseButton>
                    </li>
                    <li @click="isDropdownOpen = false">
                        <BaseButton :is-icon-only="false" variant="trans" class="!justify-between" @click="showModal">
                            <template #right>
                                <IconLogout color="red" />
                                {{ t('user.logout') }}
                            </template>
                        </BaseButton>
                    </li>
                </ul>
            </div>
        </div>
    </template>
    <!-- voucher -->
    <template v-else-if="DIR === 'voucher'">
        <div class="grow flex flex-nowrap items-center justify-end gap-[10px]">
            <div ref="dropdownRef" class="dropdown dropdown-bottom">
                <BaseButton variant="outlines" :is-icon-only="true" :is-circle="true" class="rounded-full"
                    @click="isDropdownOpen = !isDropdownOpen">
                    <template #left>
                        <IconUser size="17" />
                    </template>
                </BaseButton>
                <ul v-show="isDropdownOpen" tabindex="0"
                    class="dropdown-content menu rounded-box z-[1] w-52 !top-11 shadow bg-gray-50"
                    :class="[local === 'fa' ? 'left-0' : 'right-0']">

                    <li @click="isDropdownOpen = false">
                        <BaseButton tag="RouterLink" to="/profile" :is-icon-only="false" variant="trans"
                            class="!justify-between">
                            <template #right>
                                <IconSettings />
                                {{ t('user.userSettings') }}
                            </template>
                        </BaseButton>
                    </li>

                    <li @click="isDropdownOpen = false">
                        <BaseButton :is-icon-only="false" variant="trans" class="!justify-between" @click="showModal">
                            <template #right>
                                <IconLogout color="red" />
                                {{ t('user.logout') }}
                            </template>
                        </BaseButton>
                    </li>
                </ul>
            </div>
        </div>
    </template>
     <!-- irq -->
     <template v-else-if="DIR === 'irq'">
        <div class="grow flex flex-nowrap items-center justify-end gap-[10px]">
            <div class="py-[2px] p-2 flex items-center justify-center border-[1px] border-gray-200 rounded-full gap-1">
                <img src="/img/coin.png" alt="coin" class="w-[19px] h-[19px]">
                <span class="text-[9px] text-font-dark">
                    {{ t('user.coinIrq') }} <br> <b class="text-font-dark">{{local === 'fa' ? enToFaNum(formatNumberWithCommas(ratio ?? '0')) : formatNumberWithCommas(ratio ?? '0') }} </b> {{ t('user.rial') }}
                </span>
            </div>
            <BaseButton :is-icon-only="true" :is-circle="true" variant="outlines" @click="toggleLocale">
                <template #left>
                    <component :is="IconLanguage" size="17"></component>
                </template>
            </BaseButton>
            <div ref="dropdownRef" class="dropdown dropdown-bottom">
                <BaseButton variant="outlines" :is-icon-only="true" :is-circle="true" class="rounded-full"
                    @click="isDropdownOpen = !isDropdownOpen">
                    <template #left>
                        <IconUser size="17" />
                    </template>
                </BaseButton>
                <ul v-show="isDropdownOpen" tabindex="0"
                    class="dropdown-content menu rounded-box z-[1] w-52 !top-11 shadow bg-gray-50"
                    :class="[local === 'fa' ? 'left-0' : 'right-0']">

                    <li @click="isDropdownOpen = false">
                        <BaseButton tag="RouterLink" to="/profile" :is-icon-only="false" variant="trans"
                            class="!justify-between">
                            <template #right>
                                <IconSettings />
                                {{ t('user.userSettings') }}
                            </template>
                        </BaseButton>
                    </li>
                    <li @click="isDropdownOpen = false">
                        <BaseButton :is-icon-only="false" variant="trans" class="!justify-between" @click="showModal">
                            <template #right>
                                <IconLogout color="red" />
                                {{ t('user.logout') }}
                            </template>
                        </BaseButton>
                    </li>
                </ul>
            </div>
        </div>
    </template>
    <template v-else>
        <div class="grow flex flex-nowrap items-center justify-end gap-[10px]">

            <div ref="dropdownRef" class="dropdown dropdown-bottom">
                <BaseButton variant="outlines" :is-icon-only="true" :is-circle="true" class="rounded-full"
                    @click="isDropdownOpen = !isDropdownOpen">
                    <template #left>
                        <IconUser size="17" />
                    </template>
                </BaseButton>
                <ul v-show="isDropdownOpen" tabindex="0"
                    class="dropdown-content menu rounded-box z-[1] w-52 !top-11 shadow bg-gray-50"
                    :class="[local === 'fa' ? 'left-0' : 'right-0']">

                    <li @click="isDropdownOpen = false">
                        <BaseButton tag="RouterLink" to="/profile" :is-icon-only="false" variant="trans"
                            class="!justify-between">
                            <template #right>
                                <IconSettings />
                                {{ t('user.userSettings') }}
                            </template>
                        </BaseButton>
                    </li>

                    <li @click="isDropdownOpen = false">
                        <BaseButton :is-icon-only="false" variant="trans" class="!justify-between" @click="showModal">
                            <template #right>
                                <IconLogout color="red" />
                                {{ t('user.logout') }}
                            </template>
                        </BaseButton>
                    </li>
                </ul>
            </div>
        </div>
    </template>
</template>
